import { useEffect, useRef } from "react";
import { pb } from "../lib/pocketbaseConfig";
import { useUser } from "../contexts/UserContext";
import { useDeviceType } from "../contexts/DeviceTypeContext";

export default function DailyLoginTracker() {
  const { currentUser, loading } = useUser();
  const deviceType = useDeviceType();

  const sessionRecordIdRef = useRef<string | null>(null);
  const sessionStartRef = useRef<string | null>(null);
  const startedRef = useRef(false);
  const closingRef = useRef(false);

  const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

  useEffect(() => {
    if (loading) return;
    if (!currentUser?.$id) return;
    if (startedRef.current) return;

    startedRef.current = true;

    const startTime = new Date().toISOString();
    sessionStartRef.current = startTime;

    const createSession = async () => {
      try {
        const created = await pb.collection("daily_logins").create({
          userId: currentUser.$id,
          deviceType,
          startTime,
          status: "active",
          path: window.location.hash || window.location.pathname,
          isGuest: !!currentUser.isGuest,
          isLocalhost,
        });

        sessionRecordIdRef.current = created.id;
      } catch (error) {
        console.error("Failed to create daily_logins record:", error);
      }
    };

    const closeSession = () => {
      if (closingRef.current) return;
      closingRef.current = true;

      const recordId = sessionRecordIdRef.current;
      const startedAt = sessionStartRef.current;

      if (!recordId || !startedAt) return;

      const endDate = new Date();
      const endTime = endDate.toISOString();
const durationSeconds = Math.floor(
  (endDate.getTime() - new Date(startedAt).getTime()) / 1000
);

const durationMinutes = Math.floor(durationSeconds / 60);

      const token = pb.authStore.token;

      fetch(`${pb.baseUrl}/api/collections/daily_logins/records/${recordId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          endTime,
          durationSeconds,
            durationMinutes,
          status: "closed",
        }),
        keepalive: true,
      }).catch((error) => {
        console.error("Failed to update daily_logins end session:", error);
      });
    };

    createSession();

    const handlePageHide = () => {
      closeSession();
    };

    const handleBeforeUnload = () => {
      closeSession();
    };

    window.addEventListener("pagehide", handlePageHide);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("pagehide", handlePageHide);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      closeSession();
    };
  }, [currentUser?.$id, currentUser?.isGuest, deviceType, loading]);

  return null;
}